import InputField from '../../../services/input-fields/input-field';
import { $id } from '../../../services/jquery-utils';
import DateTimeField from '../input-fields/datetime-field';
import Unibar from '../input-fields/unibar';
import { getUnibar } from '../input-fields/unibar/unibar-storage';
import { getSelectedFlightID } from '../stopover';
import { BookingMode } from '../storage';

export default class WidgetForm {
    public bookingMode: BookingMode;
    public noFlightCheck: JQuery;
    public row1: IWidgetFormRow;
    public row2: IWidgetFormRow;

    constructor(booking: IWidgetFormRow, bookingReturn: IWidgetFormRow) {
        this.row1 = booking;
        this.row2 = bookingReturn;
        this.bookingMode = BookingMode.FromAirport;
        this.noFlightCheck = $id('flight-switch');
    }

    public setBookingMode(bookingMode: BookingMode): void {
        this.bookingMode = bookingMode;
        this.row1.bookingMode = bookingMode;
        this.row2.bookingMode = bookingMode;
    }
}

export interface IWidgetFormRow {
    bookingMode: BookingMode;
    isReturn: boolean;
    fromAddress: Unibar;
    flight: {
        getFlightID: () => number | null,
        flightNumber: InputField,
        flightDate: InputField
    };
    noflight: {
        from: Unibar,
        to: Unibar,
        datetime: DateTimeField
    };
    toAddress: Unibar;
}

let form: WidgetForm;
export function getWidgetForm(): WidgetForm {
    if (form) return form;

    return form = new WidgetForm({
        bookingMode: BookingMode.FromAirport,
        flight: {
            getFlightID: () => getSelectedFlightID(false),
            flightDate: new InputField('flightDate'),
            flightNumber: new InputField('flightNumber', true)
        },
        fromAddress: getUnibar('fromHome'),
        isReturn: false,
        noflight: {
            from: getUnibar('noflight-origin'),
            to: getUnibar('noflight-destination'),
            datetime: new DateTimeField(
                'noflight-pickup-date',
                'noflight-pickup-hours',
                'noflight-pickup-minutes')
        },
        toAddress: getUnibar('toHotel')
    }, {
            bookingMode: BookingMode.FromAirport,
            isReturn: true,
            fromAddress: getUnibar('fromHomeReturn'),
            flight: {
                getFlightID: () => getSelectedFlightID(true),
                flightNumber: new InputField('flightNumberReturn', true),
                flightDate: new InputField('flightDateReturn')
            },
            noflight: {
                from: getUnibar('noflight-destinationReturn'),
                to: getUnibar('noflight-originReturn'),
                datetime: new DateTimeField(
                    'noflight-pickup-dateReturn',
                    'noflight-pickup-hoursReturn',
                    'noflight-pickup-minutesReturn')
            },
            toAddress: getUnibar('toHotelReturn')
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/models/form.ts